/**
 * This component was generated by the icon-component-creation.mjs script. PLEASE DO NOT EDIT THIS FILE DIRECTLY.
 */

import * as React from 'react';
import { createSvgIcon } from '@mui/material';

export const FeaturePatternContainersIcon = createSvgIcon(
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 42 43"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    style={{ fillRule: 'evenodd', clipRule: 'evenodd', strokeLinejoin: 'round', strokeMiterlimit: '2' }}
  >
    <g transform="matrix(1,0,0,1,-190,-983)">
      <g id="Feature-Pattern-Containers" transform="matrix(0.542569,0,0,0.571048,169.844,377.77)">
        <g transform="matrix(0.632424,-2.57509e-16,-1.00675e-16,0.600884,-1526.37,1061.61)">
          <g id="backing">
            <path
              d="M2594.75,19.851L2594.75,102.551C2594.75,113.507 2585.85,122.401 2574.9,122.401L2492.2,122.401C2481.24,122.401 2472.35,113.507 2472.35,102.551L2472.35,19.851C2472.35,8.895 2481.24,0 2492.2,0L2574.9,0C2585.85,0 2594.75,8.895 2594.75,19.851Z"
              style={{ fill: 'none' }}
            />
          </g>
        </g>
        <g transform="matrix(-0.0349104,0.0354382,0.0622298,0.0629974,67.6696,1001.51)">
          <path
            d="M1976.07,1009.43L1977.53,626.512L1719.72,482.334L549.497,659.691L549.495,1059.59L781.804,1190.24L1976.07,1009.43ZM1497.52,579.287L1664.82,553.957L1664.82,852.138L1497.52,877.467L1497.52,579.287ZM710.821,1059.71L1691.87,911.179L1801.79,972.676L820.27,1121.28L710.821,1059.71ZM659.741,706.132L815.282,682.582L815.282,980.763L659.741,1004.31L659.741,706.132ZM1210.87,719.729L1210.87,622.688L1387.27,595.98L1387.27,894.16L1210.87,920.868L1210.87,859.41C1226.74,855.726 1241.59,850.264 1254.46,843.023C1306.91,813.518 1306.74,765.576 1254.07,736.03C1241.28,728.857 1226.57,723.423 1210.87,719.729ZM1100.62,857.582L1100.62,937.561L925.534,964.07L925.534,665.889L1100.62,639.381L1100.62,721.217C1087.23,724.813 1074.69,729.727 1063.61,735.957C1011.16,765.462 1011.34,813.404 1064,842.949C1074.99,849.11 1087.39,853.988 1100.62,857.582ZM1775.07,603.603L1866.12,654.514L1866.12,918.289L1775.07,867.353L1775.07,603.603Z"
            style={{ fill: 'white' }}
          />
        </g>
      </g>
    </g>
  </svg>,
  'FeaturePatternContainersIcon',
);
